import styled, { StyledProps } from 'styled-components/macro';

export type Props = StyledProps<{
  styles?: any;
}>;

export const Container = styled.div`
  position: relative;
`;

export const Button = styled.button`
  transition: 0.3s;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  background-color: transparent;
  border-radius: 4px;
  height: 36px;
  padding: 0 10px;
  display: flex;
  align-items: center;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    outline: none;
    border: 1px solid transparent;
  }

  &:focus {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid #fdfcfb;
    border-radius: 4px;
    outline: none;
  }

  svg {
    margin-left: 20px;
  }
`;

export const Options = styled.div<Props>`
  background: #FAFAFA;
  border-radius: 4px;
  padding: 10px 5px;
  position: absolute;
  z-index: 99;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  top: 42px;
  right: 0;
  width: 161px;

  ${(props) => props.styles}}
`;

export const Item = styled.div`
  height: 34px;
  border-radius: 4px;
  align-items: center;
  display: flex;
  padding: 0 10px;
  transition: 0.3s;
  cursor: pointer;
  color: #0a1128;
  font-size: 12px;
  font-family: 'Inter';

  svg {
    margin-right: 10px;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`;
